import { IActivityDetails, IActivityExportMetadataRequest } from "@Models/IActivityDetails";
import { Fixed, getActivityMetric, useFileDownloader, useJSONToCSV } from "@Utils";
import { useCreateActivityExportMetadata } from "../mutations";

const useActivityExport = (activities: IActivityDetails[], metadataRequest: IActivityExportMetadataRequest) => {
    const { downloadFile, isDownloading: isExporting } = useFileDownloader();
    const { mutate: createMetadata } = useCreateActivityExportMetadata();
    const { parse } = useJSONToCSV();

    const prepareData = () => {
        const data = activities.map((activity) => {
            const handedness = Fixed(getActivityMetric("handedness", activity));
            return {
                "Member ID": activity.userFullName,
                Date: activity.creationDate,
                Procedure: activity.categoryName,
                "Completion Time": activity.duration,
                Smoothness: Fixed(getActivityMetric("smoothness", activity)),
                "Distance Travelled": Fixed(getActivityMetric("distance", activity)),
                "Time On Screen": Fixed(getActivityMetric("time-on-screen", activity)),
                Acceleration: Fixed(getActivityMetric("acceleration", activity)),
                "Handedness (Left)": handedness > 0 ? Math.round(handedness) + "%" : 0,
                "Handedness (Right)": handedness > 0 ? Math.round(100 - handedness) + "%" : 0,
            };
        });

        return data;
    };

    const handleExport = () => {
        const csv = parse(prepareData());
        // this doesn't need to be async. we want the user to see the export even if the createMetadata fails
        createMetadata({ req: metadataRequest });
        downloadFile(new Blob([csv], { type: "text/csv" }), "export.csv");
    };

    return { handleExport, isExporting };
};

export default useActivityExport;
